import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { UICommand } from '../base-components/ui-command';
import {
    BaseNotification
} from '../entities/document-notifications/base-notification/base-notification.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input()
  isMain: boolean;
  @Input()
  commands: UICommand[];
  @Input()
  title: string;
  @Input()
  showNotifications: boolean;
  @Input()
  notifications: BaseNotification[];

  @Output()
  backClicked = new EventEmitter<void>();

  @Output()
  menuClicked = new EventEmitter<void>();

  @Output()
  setNotificationAsRead = new EventEmitter<BaseNotification>();

  public onBackClick() {
    this.backClicked.emit();
  }

  public onMenuClick() {
    this.menuClicked.emit();
  }

  onSetNotificationAsRead(notification: BaseNotification) {
    this.setNotificationAsRead.emit(notification);
  }

  refresh() {
    window.location.reload();
  }
}
